<template>
    <div class="header-bar w-full flex items-center justify-between px-32 py-16 relative text-white" :style="{ backgroundColor: 'var(--color-primary)', color: 'var(--color-primary-content)' }">
        <!-- Logo on the left -->
        <WFBuildingLogo :class="['wf-building-logo', mobile ? 'mobile-logo' : 'portrait-logo']"/>
        
        <!-- Language Dropdown in the center - ONLY for mobile -->
        <div class="header-center">
            <CustomLanguageDropdown v-if="mobile" class="mobile-language-dropdown" />
        </div>
        
        <!-- Clock & Date on the right - conditionally shown based on settings -->
        <div v-if="settings.showClock || settings.showDate" class="header-dt">
            <WFClock v-if="settings.showClock" class="p-0 hidden md:block"/>
            <WFDate v-if="settings.showDate" class="hidden md:block"/>
        </div>
    </div>
</template>

<script>
import { WFBuildingLogo, WFClock } from '@3dwayfinder/wayfinder-vue-components'
import CustomLanguageDropdown from "@/components/CustomLanguageDropdown.vue";
import { mapState } from "vuex";

export default {
    name: 'THHeader',
    components: {
		WFBuildingLogo,
        WFClock,
        CustomLanguageDropdown,
    },
    props: {
        settings: {
            type: Object,
            default: () => ({ showClock: true, showDate: true })
        }
    },
    computed: {
        ...mapState("wf", ["mobile"]),
    },
}
</script>

<style lang="postcss">
    .header-bar {
        height: 14rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: var(--th-primary);
    }
    
    .wf-building-logo {
        background-position: center left !important;
        background-size: contain !important;
        background-repeat: no-repeat !important;
        flex: 0 0 auto;
        margin-left: 0;
    }
    
    /* Mobile logo size */
    .mobile-logo {
        height: 80%;
        max-width: 30rem;
        min-width: 16rem;
    }
    
    /* Portrait logo size (bigger) */
    .portrait-logo {
        height: 90%;
        max-width: 45rem;
        min-width: 25rem;
    }
    
    .header-center {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }
    
    .header-dt {
        text-align: right;
        flex-shrink: 0;
        flex: 0 0 auto;
    }
    
    .wf-clock {
        font-size: 4rem;
		font-weight: 500;
        padding: 0;
        margin-bottom: 0.5rem;
    }

    .wf-date {
        font-size: 2.4rem;
        font-weight: 500;
    }
    /* ===== 4K PORTRAIT ONLY - Header ===== */
@media (orientation: portrait) and (min-width: 2160px) {
  .header-bar {
    height: 28rem !important; /* 14rem * 2 */
    padding: 3.2rem 6.4rem !important; /* px-32 py-16 * 2 */
  }
  
  /* Logo - 2x */
  .portrait-logo {
    height: 90% !important;
    max-width: 90rem !important; /* 45rem * 2 */
    min-width: 50rem !important; /* 25rem * 2 */
  }
  
  .wf-building-logo {
    height: 90% !important;
  }
  
  /* Clock - 2x */
  .wf-clock {
    font-size: 8rem !important; /* 4rem * 2 */
    margin-bottom: 1rem !important;
  }
  
  /* Date - 2x */
  .wf-date {
    font-size: 4.8rem !important; /* 2.4rem * 2 */
  }
  
  /* Language flags - CORRECT SELECTOR - 2x */
  .flag-button,
  button.flag-button {
    width: 102px !important; /* 66px * 2 */
    height: 80px !important; /* 50px * 2 */
    min-width: 102px !important;
    min-height: 80px !important;
  }
  
  .flag-button img {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>